var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-pen"},[_c('Pen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }